export default __webpack_public_path__ + "static/media/35.876077a4.png";